import $ from 'jquery'
import toastr from 'toastr/toastr'

window.toastr = toastr;

$.fn.toastrEnter = function (options) {
    const duration = (options && options.duration) ?? 300;
    const complete = options && options.complete;
    const $el = this;

    if ($el.data('toastr-shown')) {
        $el.css({display: 'block', opacity: 1, transform: 'none'});
        if (typeof complete === 'function') {
            complete();
        }
        return $el;
    }

    $el.data('toastr-shown', true);
    $el.css({display: 'block', opacity: 0, transform: 'translateX(24px)'});
    $el[0].offsetHeight;
    $el.css('transition', 'transform ' + duration + 'ms cubic-bezier(.16,1,.3,1), opacity ' + duration + 'ms ease-out');

    requestAnimationFrame(function () {
        $el.css({opacity: 1, transform: 'none'});
    });

    setTimeout(function () {
        $el.css('transition', '');
        if (typeof complete === 'function') {
            complete();
        }
    }, duration);

    return $el;
};

$.fn.toastrLeave = function (options) {
    const duration = (options && options.duration) ?? 300;
    const complete = options && options.complete;
    const $el = this;

    $el.css('transition', 'transform ' + duration + 'ms cubic-bezier(.4,0,1,1), opacity ' + duration + 'ms ease-in');

    requestAnimationFrame(function () {
        $el.css({opacity: 0, transform: 'translateX(24px)'});
    });

    setTimeout(function () {
        $el.css('transition', '').hide();
        if (typeof complete === 'function') {
            complete();
        }
    }, duration);

    return $el;
};

toastr.options = Object.assign({}, toastr.options, {
    showMethod: 'toastrEnter',
    hideMethod: 'toastrLeave',
    showDuration: 300,
    hideDuration: 300,
    extendedTimeOut: 6000,
    closeHtml: '<button type="button"><i class="far fa-xmark"></i></button>',
});

const activeToasts = new Map();

['success', 'error', 'warning', 'info'].forEach(function (type) {
    const original = toastr[type].bind(toastr);

    toastr[type] = function (message, title, options) {
        const key = type + '|' + (title ?? '') + '|' + message;
        const previous = activeToasts.get(key);
        const count = previous ? previous.count + 1 : 1;

        if (previous) {
            const previousHideDuration = toastr.options.hideDuration;
            toastr.options.hideDuration = 0;
            toastr.clear(previous.element, {force: true});
            toastr.options.hideDuration = previousHideDuration;
        }

        const entry = {count: count};
        activeToasts.set(key, entry);

        const mergedOptions = Object.assign({}, options, {
            onHidden: function () {
                if (activeToasts.get(key) === entry) {
                    activeToasts.delete(key);
                }
                if (options && typeof options.onHidden === 'function') {
                    options.onHidden();
                }
            },
        });

        const suffix = count > 1 ? ' (×' + count + ')' : '';
        const displayTitle = title ? title + suffix : title;
        const displayMessage = title ? message : message + suffix;

        entry.element = original(displayMessage, displayTitle, mergedOptions);

        return entry.element;
    };
});
